import CandidateAddressBook from '../../pages/candidate/addressbook';
import CandidateHelpCenter from '../../pages/candidate/helpcenter';
import CandidateLMScertificates from '../../pages/candidate/lms/certificates/containers/certificates';
import CandidateUsersLMSCertifiedUsers from '../../pages/candidate/lms/certified-users/containers/certified-users';
import CandidateLMSChapter from '../../pages/candidate/lms/chapters/containers/chapter';
import CandidateLMSChapters from '../../pages/candidate/lms/chapters/containers/chapters';
import CandidateLMSCollection from '../../pages/candidate/lms/collections/containers/collection';
import CandidateLMSCollections from '../../pages/candidate/lms/collections/containers/collections';
import CandidateLMSCourse from '../../pages/candidate/lms/courses/containers/course';
import CandidateLMSCourses from '../../pages/candidate/lms/courses/containers/courses';
import CandidateLMSLearningPath from '../../pages/candidate/lms/learning-paths/containers/learning-path';
import CandidateLMSLearningPaths from '../../pages/candidate/lms/learning-paths/containers/learning-paths';
import CandidateLMSModule from '../../pages/candidate/lms/modules/containers/module';
import CandidateLMSModules from '../../pages/candidate/lms/modules/containers/modules';
import CandidateLMSTopic from '../../pages/candidate/lms/topics/containers/topic';
import CandidateLMSTopics from '../../pages/candidate/lms/topics/containers/topics';
import CandidateProfile from '../../pages/candidate/profile';
import CandidateWorkingInProgress from '../../pages/candidate/wip';
import { RoleGuard } from '../guards';



export const CandidateRoutes = () => {

	return ([
		
		// Start - Profile
		{ path: 'profile', element: <RoleGuard roles={["Candidate"]}><CandidateProfile /></RoleGuard>},
		{ path: 'helpcenter', element: <RoleGuard roles={["Candidate"]}><CandidateHelpCenter /></RoleGuard>},
		{ path: 'address', element: <RoleGuard roles={["Candidate"]}><CandidateAddressBook /></RoleGuard>},
		{ path: 'wip', element: <RoleGuard roles={["Candidate"]}><CandidateWorkingInProgress /></RoleGuard>},

        { path: "lms/certificates", element: <RoleGuard roles={["Internal"]}><CandidateLMScertificates /></RoleGuard> },
		{ path: "lms/certified-users", element: <RoleGuard roles={["Internal"]}><CandidateUsersLMSCertifiedUsers /></RoleGuard> },
		{ path: "lms/chapters", element: <RoleGuard roles={["Internal"]}><CandidateLMSChapters /></RoleGuard> },
		{ path: "lms/chapters/:id", element: <RoleGuard roles={["Internal"]}><CandidateLMSChapter /></RoleGuard> },
		{ path: "lms/collections", element: <RoleGuard roles={["Internal"]}><CandidateLMSCollections /></RoleGuard> },
		{ path: "lms/collections/:id", element: <RoleGuard roles={["Internal"]}><CandidateLMSCollection /></RoleGuard> },
		{ path: "lms/courses", element: <RoleGuard roles={["Internal"]}><CandidateLMSCourses /></RoleGuard> },
		{ path: "lms/courses/:id", element: <RoleGuard roles={["Internal"]}><CandidateLMSCourse /></RoleGuard> },
		{ path: "lms/learning-paths", element: <RoleGuard roles={["Internal"]}><CandidateLMSLearningPaths /></RoleGuard> },
		{ path: "lms/learning-paths/:id", element: <RoleGuard roles={["Internal"]}><CandidateLMSLearningPath /></RoleGuard> },
		{ path: "lms/modules", element: <RoleGuard roles={["Internal"]}><CandidateLMSModules /></RoleGuard> },
		{ path: "lms/modules/:id", element: <RoleGuard roles={["Internal"]}><CandidateLMSModule /></RoleGuard> },
		{ path: "lms/topics", element: <RoleGuard roles={["Internal"]}><CandidateLMSTopics /></RoleGuard> },
		{ path: "lms/topics/:id", element: <RoleGuard roles={["Internal"]}><CandidateLMSTopic /></RoleGuard> },
	])	
};
